<ng-form id="fieldForm" #fieldForm="ngForm" novalidate>

  <a (click)="delete()">
    <mat-icon>delete</mat-icon>
  </a>

  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label>Field is ...</mat-label>
      <mat-select #field="ngModel" name="keyList" [(ngModel)]="searchFieldCopy.name" required
        pattern="(?!^Unknown$)(^.*$)" (selectionChange)="fieldChanged(searchFieldCopy.name)"
        (change)="formChanged(value)">
        <ngx-mat-select-search name="keySearch" [(ngModel)]="keySearch" [placeholderLabel]="'Search...'"
          [noEntriesFoundLabel]="'notfound'"></ngx-mat-select-search>

        <mat-option [value]="searchField.name" selected>{{searchField.name}}</mat-option>
        <mat-option *ngFor="let key of availableKeys | stringFilterBy : keySearch: 'name' " [value]="key.name">
          {{key.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <ng-container [ngSwitch]="searchField?.type">

    <ng-container *ngSwitchCase="dynamicObjectType.Text">
      <span>contains</span>
      <div class="form-container">
        <mat-form-field appearance="outline">
          <mat-label>{{searchField.name}} contains ...</mat-label>
          <input matInput #textFilter="ngModel" name="textFilter" [(ngModel)]="value" (change)="formChanged(value)"
            required pattern="^[^\'\+\-\*\?\&quot;]+$" />

          <mat-error>Special characters and punctuation are not supported
          </mat-error>
        </mat-form-field>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="dynamicObjectType.Number">
      <span>equals</span>
      <div class="form-container">
        <mat-form-field appearance="outline">
          <mat-label>{{searchField.name}} equals ...</mat-label>
          <input type="number" matInput name="numbrFilter" [(ngModel)]="value" (change)="formChanged(value)" required />
        </mat-form-field>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="dynamicObjectType.Boolean">
      <span>is</span>
      <div class="form-container">
        <mat-form-field appearance="outline">
          <section class="custom-check-box-group">
            <!-- <mat-checkbox class="custom-check-box" name="fieldChecked" [(ngModel)]="value" (change)="formChanged(value)">
            Is
            true</mat-checkbox> -->
            <mat-select #fieldChecked="ngModel" name="fieldChecked" [(ngModel)]="value" required
              (selectionChange)="formChanged(value)">
              <mat-option value="" selected disabled>Please select a value</mat-option>
              <mat-option value="true">Yes</mat-option>
              <mat-option value="false">No</mat-option>
            </mat-select>
          </section>
        </mat-form-field>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="dynamicObjectType.BusinessOwner">
      <span>is</span>
      <div class="form-container">
        <mat-form-field appearance="outline" *ngIf="null | asyncBusinessOwnerAll | async as ownerAll">
          <mat-label>Business Owner is ...</mat-label>
          <mat-select #ContractBusinessOwner="ngModel" name="ContractBusinessOwner" [(ngModel)]="value" required
            (selectionChange)="formChanged(value)">
            <ngx-mat-select-search name="boSearch" [(ngModel)]="boSearch" [placeholderLabel]="'Search...'"
              [noEntriesFoundLabel]="'notfound'"></ngx-mat-select-search>

            <mat-option value="" disabled selected>Please select</mat-option>
            <mat-option *ngFor="let ownr of ownerAll | stringFilterBy : boSearch : 'fullname'" [value]="ownr.id">
              {{ownr.fullname}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="dynamicObjectType.LegalCounsel">
      <span>is</span>
      <div class="form-container">
        <mat-form-field appearance="outline" *ngIf="null | asyncLegalCounselAll | async as legalCounselAll">
          <mat-label>Legal Counsel is ...</mat-label>
          <mat-select #ContractLegalCounsel="ngModel" name="ContractLegalCounsel" [(ngModel)]="value" required
            (selectionChange)="formChanged(value)">
            <ngx-mat-select-search name="boSearch" [(ngModel)]="boSearch" [placeholderLabel]="'Search...'"
              [noEntriesFoundLabel]="'notfound'"></ngx-mat-select-search>

            <mat-option value="" disabled selected>Please select</mat-option>
            <mat-option *ngFor="let legalCounsel of legalCounselAll | stringFilterBy : boSearch : 'fullname'" [value]="legalCounsel.id">
              {{legalCounsel.fullname}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="dynamicObjectType.Lookup">
      <span>is</span>
      <div class="form-container">

        <app-multiselect-wrapper label="one of..." name="listSelect" #SelectList="ngModel" [(ngModel)]="value"
          [choiceListName]="searchField.lookupName" [gerritServiceName]="searchField.gerritLookup" [required]="true"
          [objectStore]="objectStore" [allowSearchFilter]="true" [allowCheckAll]="true" [singleSelection]="false"
          (changed)="formChanged(value)" [limitSelections]="5">
        </app-multiselect-wrapper>

      </div>
    </ng-container>

    <ng-container *ngSwitchCase="dynamicObjectType.Folder">
      <span>is</span>
      <div class="form-container">
        <ng-template #loading>
          <h4>Loading ...</h4>
        </ng-template>
        <mat-form-field appearance="outline" *ngIf="folders$ | async as folders; else loading">
          <mat-label *ngIf="!valueLibrary">Filed in ... </mat-label>
          <mat-label *ngIf="valueLibrary">{{valueLibrary}}</mat-label>
          <mat-select #LibraryDropDown="ngModel" name="FolderFilder" [(ngModel)]="valueLibrary"
            [required]="!valueLibrary && valueLibrary !== 'ALL'" (selectionChange)="formChangedLibrary(valueLibrary)">
            <ngx-mat-select-search name="folderSearch" [(ngModel)]="folderSearch" [placeholderLabel]="'Search...'"
              [noEntriesFoundLabel]="'notfound'"></ngx-mat-select-search>

            <mat-option value="" disabled selected>Please select</mat-option>
            <mat-option value="/" selected>All</mat-option>
            <ng-container *ngFor="let fldrCat of folders | stringFilterBy : folderSearch : 'propertiesObj.PathName'">

              <mat-option [value]=" fldrCat?.propertiesObj?.PathName">
                {{fldrCat?.propertiesObj?.PathName}}
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>
      <ng-container *ngIf="valueLibrary && valueLibrary !== '/' ">
        <span>&nbsp;</span>
        <label>Sub Folder</label>
        <span>is</span>
        <div class="form-container">
          <ng-template #loading>
            <h4>Loading ...</h4>
          </ng-template>
          <mat-form-field appearance="outline" *ngIf="folderCategory$ | async as folders; else loading">
            <mat-label>Filed in ...</mat-label>

            <mat-select #SubFolder="ngModel" name="FolderFilder" [(value)]="value" [(ngModel)]="value" required
              (selectionChange)="formChanged(value)">
              <ngx-mat-select-search name="subFolderSearch" [(ngModel)]="subFolderSearch"
                [placeholderLabel]="'Search...'" [noEntriesFoundLabel]="'notfound'"></ngx-mat-select-search>

              <mat-option value="" disabled selected>Please select</mat-option>
              <mat-option [value]="valueLibrary" selected>All</mat-option>
              <ng-container
                *ngFor="let fldrCat of folders | stringFilterBy : subFolderSearch : 'propertiesObj.PathName'">
                <mat-option [value]=" fldrCat.propertiesObj.PathName">
                  {{fldrCat.propertiesObj.PathName}}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngSwitchCase=" dynamicObjectType.Date">
      <span>between</span>
      <div class="dateRange">
        <div class="form-container">
          <mat-form-field appearance="outline">
            <mat-label>After Date</mat-label>
            <input #afterDate="ngModel" name="afterDate" [(ngModel)]="valueFrom" matInput
              [matDatepicker]="pickerDateFrom" placeholder="Choose a date yyyy/mm/dd" required [max]="valueTo"
              (dateChange)="formChanged(valueFrom)" />
            <mat-datepicker-toggle matSuffix [for]="pickerDateFrom">
              <mat-icon matDatepickerToggleIcon><img src="assets/images/icon-calender.svg" /></mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #pickerDateFrom></mat-datepicker>
          </mat-form-field>
        </div>
        <span>and</span>
        <div class="form-container">
          <mat-form-field appearance="outline">
            <mat-label>Before Date</mat-label>
            <input #toDate="ngModel" name="toDate" [(ngModel)]="valueTo" matInput [matDatepicker]="pickerDateTo"
              placeholder="Choose a date yyyy/mm/dd" required [min]="valueFrom" (dateChange)="formChanged(valueTo)" />
            <mat-datepicker-toggle matSuffix [for]="pickerDateTo">
              <mat-icon matDatepickerToggleIcon><img src="assets/images/icon-calender.svg" /></mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #pickerDateTo></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <div *ngSwitchDefault>
        {{searchField.name}}
      </div>
    </ng-container>
